import { useQuery } from '@tanstack/react-query';
import { getSubdomain, isValidSubdomain } from '@zealy/utils';
import { tradingCompetitionKeys } from '../tradingCompetition.keys';
import { getUserTradingRank } from '../tradingCompetition.service';
/**
 * Queries a user's trading rank and data for a specific trading competition
 * @param tradingCompetitionId The ID of the trading competition
 * @param userId The ID of the user (defaults to 'me' for current user)
 * @param subdomain The subdomain of the community, defaults to current subdomain
 * @param enabled Whether the query should be enabled
 */
export const useUserTradingRank = (tradingCompetitionId, userId = 'me', subdomain, enabled = true) => {
    const domain = subdomain || getSubdomain();
    return useQuery({
        queryKey: tradingCompetitionKeys.userTradingRank(domain, tradingCompetitionId, userId),
        queryFn: async () => getUserTradingRank(domain, tradingCompetitionId, userId),
        enabled: isValidSubdomain(domain) && !!tradingCompetitionId && enabled,
        staleTime: 30000, // 30 seconds
        retry: 1,
    });
};
